'use client';

import { useApplicationDoctor } from '@/contexts/application-doctor-context';
import { resizeImage } from '@/lib/resizeImage';
import { Logo, LogoIcon } from '@/components/shared/logo';
import { doctorName } from '@/lib/utils';
import { useTranslation } from '@/contexts/language-context';

export function DoctorHeader({
  doctor: doctorProp,
  showPoweredBy = false,
  isCheckout = false,
  // Overrides from the checkout session's storefront branding: `image` is a
  // full URL used as-is (unlike doctor.image, which goes through the resize
  // proxy), `name` replaces the doctor's display name.
  image,
  name
}) {
  const { t } = useTranslation();
  const context = useApplicationDoctor();
  const doctor = doctorProp || context?.doctor;

  if (!doctor && !name) return null;

  let imageSrc;
  let displayName;
  if (isCheckout) {
    imageSrc = image;
    displayName = name;
  } else {
    imageSrc =
      image || (doctor?.image ? resizeImage(doctor.image, 'thumb') : null);
    displayName = name || doctorName(doctor);
  }

  return (
    <header
      className={`relative w-full overflow-hidden text-white ${
        showPoweredBy ? 'bg-[#405e93]' : 'bg-dark-gradient'
      }`}
    >
      <div className="relative z-10 mx-auto flex w-full max-w-7xl items-center justify-between gap-8 px-4 py-3">
        <div className="flex min-w-0 items-center gap-3.5">
          {imageSrc && (
            <img
              src={imageSrc}
              alt={displayName}
              className="size-10 shrink-0 rounded-full object-cover"
            />
          )}
          {displayName && (
            <h1 className="truncate text-base leading-tight">{displayName}</h1>
          )}
        </div>
        {showPoweredBy && (
          <div className="flex shrink-0 flex-col items-end gap-1">
            <p className="text-xs uppercase tracking-wide">
              {t('root.poweredBy', 'Powered by')}
            </p>
            <Logo className="w-24" aria-label="Beautifi" />
          </div>
        )}
      </div>
      {!showPoweredBy && (
        <LogoIcon className="h-28 w-auto absolute right-10 -top-6 z-0 translate-x-1/4 pointer-events-none text-neutral/20" />
      )}
    </header>
  );
}
